import { IUserDataResponse, IUserData } from '../auth-types'

class GetUserData {
  private mapEmergencyContact(
    contact?: IUserDataResponse['contatoEmergencia'],
  ) {
    return {
      relationship: contact?.relacao || '',
      fullName: contact?.nomeCompleto || '',
      cellphone: contact?.telefone || '',
      emergencyContactId: contact?.idContatoEmergencia || null,
    }
  }

  private mapClinic(clinic?: IUserDataResponse['usuario']['clinica']) {
    return {
      id: clinic?.id || null,
      product: clinic?.produto || '',
    }
  }

  private mapPatient(patient?: IUserDataResponse['usuario']['paciente']) {
    return {
      address: {
        cep: patient?.cep || '',
        formattedCep: patient?.cepFormatado || '',
        streetName: patient?.endereco || '',
        number: patient?.numeroLogradouro || '',
        complement: patient?.complemento || '',
        neighborhood: patient?.bairro || '',
        city: patient?.cidade || '',
        state: patient?.uf || '',
      },
      birthDate: patient?.dataNascimento || '',
      email: patient?.email || '',
      name: patient?.nome || '',
      phoneNumber: patient?.telefoneCelular || '',
      parsedPhoneNumber: patient?.telefoneCelularFormatado || '',
      holder: patient?.titularidade || '',
      photo: patient?.urlFoto || '',
      socialName: patient?.nomeSocial || '',
      passport: patient?.passaporte || '',
      dateIssuePassport: patient?.dataEmissaoPassaporte || '',
      passportExpirationDate: patient?.dataValidadePassaporte || '',
      foreignBirthCountryId: patient?.idPaisNascimentoEstrangeiro || null,
      birthState: patient?.ufNascimento || '',
      issuingBodyRg: patient?.orgaoEmissorIdentidade || '',
      dateIssueRg: patient?.dataEmissaoIdentidade || '',
      rg: patient?.identidade || '',
      cpf: patient?.cpf || '',
      ethnicity: patient?.etnia || '',
      idGenre: patient?.idGenero || null,
      idNacionality: patient?.idNacionalidade || null,
      idRaceOrColor: patient?.idRacaCor || null,
      nameMother: patient?.nomeMae || '',
      unknownMother: !!patient?.flagMaeDesconhecida,
      cns: patient?.cns || '',
      sex: patient?.sexo || '',
      birthCity: patient?.municipioNascimento || '',
      idUfBirth: patient?.idUfNascimento || null,
      healthInsuranceNumber: patient?.carteiraConvenio || '',
      needToUpdateAccountData: !!patient?.pendenteAtualizacaoDadosCadastrais,
    }
  }

  toDomain(data: IUserDataResponse): IUserData {
    return {
      contactsEmergency: this.mapEmergencyContact(data?.contatoEmergencia),
      user: {
        id: data?.usuario?.id || null,
        blocked: !!data?.usuario?.flagBloqueado,
        idPatient: data?.usuario?.idDoPaciente || null,
        clinic: this.mapClinic(data?.usuario?.clinica),
        patient: this.mapPatient(data?.usuario?.paciente),
      },
    }
  }
}

export default new GetUserData()
